import { render, staticRenderFns } from "./order-documents.vue?vue&type=template&id=216d1e4b&scoped=true"
import script from "./order-documents.vue?vue&type=script&lang=ts"
export * from "./order-documents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216d1e4b",
  null
  
)

export default component.exports